import React from 'react';
import { Text, RichText } from '@sitecore-jss/sitecore-jss-react';
import './style.scss';
import Button from '../Shared/components/controls/Button';

const Taxonomy = (props) => {
  return (
    <div className="RadeemBox">
      <div className="container">
        <div className="row">
          <div className="col-md-5">
            <div className="deatilHeader">
              <h4>
                <Text field={props?.fields?.heading} />
              </h4>
              {props?.fields?.link?.value?.text && (
                <Button
                  link={props?.fields?.link}
                  variant="contained"
                  color="secondary"
                  arrow="right"
                >
                  {props?.fields?.link?.value?.text}
                </Button>
              )}
            </div>
          </div>
          <div className="col-md-7">
            <div className="deatilHeader">
              <RichText field={props?.fields?.text} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Taxonomy;
